export const LANG_FR_NAME = 'fr';

export const LANG_FR_TRANS = {
    login: 'Connexion',
    selectLanguage: 'Choisir la langue',
    profileChoose: 'Veuillez choisir votre spécialité et votre langue',
    speciality: 'Spécialité',
    language: 'Langue',
    saveAndContinue: 'Enregistrer et continuer',
    capitalChoose: 'Vous pouvez choisir un chapitre ici.',
    questions: 'QUESTIONS',
    question: 'Question',
    dashboard: 'APERÇU',
    logout: 'Déconnexion',

    //Question buttons
    previous: 'Précédent',
    next: 'Suivant',
    finish: 'Terminer',
    checkAnswer: 'Vérifier la réponse',
    source: 'Source :',

    //Dashboard
    trackStatistics: 'Suivez vos statistiques',
    correct: 'Correct',
    wrong: 'Incorrect',
    unanswered: 'Sans réponse',
    percentCorrect: '% correct',
    capital: 'Chapitre',
    total: 'Total',
    practiceFailed: 'S\'entraîner sur les questions échouées',
    practiceUnanswered: 'S\'entraîner sur les questions sans réponse',
    resetQuestions: 'Réinitialiser toutes les questions',
    resetQuestionNotification: 'Vos réponses ont été réinitialisées.',
    resetNoQuestionNotification: 'Vous n\'avez aucune question à réinitialiser',
    yes: 'Oui',
    no: 'Non',
    resetConfirmMessage: 'Voulez-vous vraiment supprimer toutes vos réponses ?',
    wrongQuestionNotification: 'Vous n\'avez aucune question incorrecte.',
    unansweredQuestionNotification: 'Vous n\'avez aucune question sans réponse.',
    anyQuestionNotification: 'Vous n\'avez aucune question.',


    //Login
    emailValidError: 'Veuillez saisir une adresse e-mail valide',
    emailRequiredError: 'Veuillez saisir votre adresse e-mail',
    passwordInputError: 'Veuillez saisir votre mot de passe',
    password: 'Mot de passe',
    email: 'E-mail',
    forgotPassword: 'Mot de passe oublié',
    passwordRecovery: 'Récupération du mot de passe',
    enterEmail: 'Veuillez saisir votre e-mail et nous vous enverrons un nouveau mot de passe',
    send: 'Envoyer',
    forgotEmail: 'E-mail oublié',
    checkEmail: 'Vérifiez votre e-mail',
    checkEmailMessage: 'Nous vous avons envoyé un e-mail, veuillez le consulter pour réinitialiser votre mot de passe.',
    returnLogin: 'Retour à la connexion',
    contactMessage1: 'Vous pouvez nous contacter à ',
    contactEmail: 'support@medexam.app',
    contactMessage2: ' pour récupérer votre e-mail enregistré.',
    noSendEmail: 'L\'e-mail n\'a pas pu être envoyé. Veuillez réessayer plus tard.',
    setNewPassword: 'Définir un nouveau mot de passe',
    setNewPasswordHint: 'Saisissez un nouveau mot de passe pour votre compte.',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    savePassword: 'Enregistrer le mot de passe',
    resetPasswordSuccess: 'Votre mot de passe a été mis à jour. Vous pouvez maintenant vous connecter.',
    resetPasswordError: 'Ce lien est invalide ou a expiré. Veuillez en demander un nouveau.',

    correctPercentage: 'Pourcentage de réponses correctes',

    // Guest demo
    demoTitle: 'Essayez 10 questions gratuites',
    demoIntro: 'Répondez à 10 questions d’entraînement sans inscription ni paiement. La banque complète reste disponible après l’achat.',
    demoStart: 'Démarrer la démo',
    demoContinue: 'Continuer la démo',
    demoFreeQuestions: 'Essayez 10 questions gratuites',
    demoLoginLink: 'Connexion',
    demoBadge: 'Démo gratuite',
    demoOf: 'sur',
    demoFallbackNotice: 'Questions d’exemple : l’API invité n’est pas encore disponible.',
    demoUnavailable: 'La démo est temporairement indisponible. Veuillez réessayer plus tard.',
    demoFinishedTitle: 'Démo terminée',
    demoFinishedLead: 'Vous avez utilisé vos 10 questions gratuites. Débloquez la banque complète pour continuer à vous entraîner.',
    demoScoreCaption: 'bonnes réponses',
    demoPurchaseCta: 'Acheter les questions d’examen',
    demoAlreadyCompleted: 'Vous avez déjà terminé les 10 questions gratuites dans ce navigateur.',
    demoSeeResults: 'Voir les résultats',

    // Mock exam
    mockTest: 'EXAMEN BLANC',
    mockIntro: 'Simulation chronométrée de l’EDAIC Part 1 : Paper A (Basic Sciences) et Paper B (Clinical Practice).',
    mockRuleQuestions: '60 questions comportant chacune jusqu’à 5 affirmations vrai ou faux',
    mockRuleScoring: '1 point par affirmation correctement jugée, pas de points négatifs ; une réponse vide vaut 0',
    mockRuleFeedback: 'Aucun retour avant la fin de l’examen',
    mockPaperA: 'Paper A',
    mockPaperATitle: 'Sciences fondamentales',
    mockPaperATopic1: 'Physiologie',
    mockPaperATopic2: 'Pharmacologie',
    mockPaperATopic3: 'Physique, mesures cliniques et statistiques',
    mockPaperB: 'Paper B',
    mockPaperBTitle: 'Pratique clinique',
    mockPaperBTopic1: 'Anesthésie générale',
    mockPaperBTopic2: 'Anesthésie locorégionale',
    mockPaperBTopic3: 'Anesthésie spécialisée, y compris la douleur',
    mockPaperBTopic4: 'Médecine intensive',
    mockPaperBTopic5: 'Médecine interne',
    mockPaperBTopic6: 'Médecine d’urgence',
    mockDuration: 'Durée',
    mockDurationPaper: '120 min (épreuve papier)',
    mockDurationComputer: '90 min (épreuve informatisée)',
    mockStart: 'Commencer l’examen',
    mockShortfallTitle: 'Questions insuffisantes',
    mockShortfallLine: '{paper} · {area} : {available} sur {requested} disponibles',
    mockResumeTitle: 'Examen non terminé',
    mockResumeBody: 'Vous avez un examen en cours qui n’a pas encore expiré.',
    mockResume: 'Reprendre l’examen',
    mockHistory: 'Examens précédents',
    mockHistoryEmpty: 'Aucun examen terminé pour le moment.',
    mockSubmitted: 'Remis',
    mockScore: 'Score',
    mockResultLink: 'Résultat',
    mockRemaining: 'Temps restant',
    mockFlag: 'Marquer',
    mockFlagged: 'Marquée',
    mockSubmit: 'Terminer l’examen',
    mockSubmitShort: 'Remettre',
    mockSubmitConfirm: 'Voulez-vous vraiment remettre l’examen ?',
    mockPartial: 'Partiellement répondu',
    mockAnswered: 'Répondu',
    mockNavigator: 'Tableau des questions',
    mockNavigatorSummary: 'Tableau des questions ({answered}/{total} répondues, {flagged} marquées)',
    mockResultTitle: 'Résultat',
    mockPassed: 'Réussi',
    mockFailed: 'Non réussi',
    mockPassGuide: 'Valeur indicative {threshold} % ; le seuil officiel de l’ESAIC varie chaque année',
    mockAreas: 'Points par matière',
    mockArea: 'Matière',
    mockReview: 'Correction',
    mockYourAnswer: 'Votre réponse',
    mockCorrectIs: 'Bonne réponse',
    mockBlankAnswer: 'Vide',
    mockHint: 'Indication',
    mockPoint: 'point',
    mockPoints: 'points',
    mockBack: 'Retour à l’examen blanc',
    mockTrue: 'Vrai',
    mockFalse: 'Faux',
    mockLoadError: 'Impossible de charger l’examen. Veuillez réessayer.',
    mockSubscriptionTitle: 'Abonnement requis',
    mockSubscriptionBody: 'Un abonnement actif est nécessaire pour l’examen blanc.',
    mockSubscriptionKept: 'Vos réponses déjà données restent enregistrées.',
    mockSubscribe: 'S’abonner',
    mockSubmitError: 'Impossible de remettre l’examen. Veuillez réessayer.',
    mockTimeUp: 'Le temps est écoulé. Vos réponses sont envoyées.',
    mockSelectPaper: 'Veuillez choisir un paper.',
    mockArea_statistics: 'Statistiques',
    mockArea_physiology: 'Physiologie',
    mockArea_pharmacology: 'Pharmacologie',
    mockArea_physics: 'Physique et mesures cliniques',
    mockArea_general_anaesthesia: 'Anesthésie générale',
    mockArea_regional_anaesthesia: 'Anesthésie locorégionale',
    mockArea_special_anaesthesia: 'Anesthésie spécialisée',
    mockArea_intensive_care: 'Médecine intensive',
    mockArea_internal_medicine: 'Médecine interne',
    mockArea_emergency_medicine: 'Médecine d’urgence',

    // Accessibility: answer states, result announcement, list status, dashboard sorting
    answerSelected: 'Sélectionnée',
    answerCorrectSelected: 'Correcte – vous l’avez sélectionnée',
    answerCorrectMissed: 'Bonne réponse – non sélectionnée',
    answerWrongSelected: 'Incorrecte – vous l’avez sélectionnée',
    answerWrongNotSelected: 'Incorrecte – à juste titre non sélectionnée',
    resultCorrect: 'Correct.',
    resultWrong: 'Incorrect.',
    resultDetail: '{correct} affirmations sur {total} jugées correctement.',
    statusCorrect: 'Répondu correctement',
    statusWrong: 'Répondu faux',
    statusUnanswered: 'Pas encore répondu',
    weakestTopic: 'Thème le plus faible',
    sortBy: 'Trier par',
    sortedAscending: 'tri croissant',
    sortChapterOrder: 'Ordre des chapitres',
    sortWeakestFirst: 'Les plus faibles d’abord (% correct, croissant)',
    sortOriginal: 'Ordre par défaut',
    answerLegendTitle: 'Comment lire l’affichage ?',
    answerLegendCorrect: 'L’affirmation est correcte et fait partie de la solution.',
    answerLegendWrong: 'L’affirmation est incorrecte et ne fait pas partie de la solution.',
    answerLegendSelection: 'Le texte à côté du symbole indique si vous avez sélectionné l’affirmation. Les couleurs ne sont qu’une aide supplémentaire.',
    mockTimerStart: 'L’examen a commencé. Vous disposez de {time}.',
    mockTimerLeft: 'Il reste {time}.',
    mockTimerEnd: 'Temps écoulé.',
    mockTimerMinutes: '{n} minutes',
    mockTimerMinute: '1 minute',
    mockTimerSeconds: '{n} secondes',
};
